export default {
  default: () => import("/private/tmp/nix-build-festival-manager-0.0.1.drv-0/incl/layouts/default.vue").then(m => m.default || m),
  screening: () => import("/private/tmp/nix-build-festival-manager-0.0.1.drv-0/incl/layouts/screening.vue").then(m => m.default || m),
  selection: () => import("/private/tmp/nix-build-festival-manager-0.0.1.drv-0/incl/layouts/selection.vue").then(m => m.default || m),
  tablet: () => import("/private/tmp/nix-build-festival-manager-0.0.1.drv-0/incl/layouts/tablet.vue").then(m => m.default || m)
}